import { LABEL } from "@/components/tool-kit/styles";
import { parseTones } from "@/lib/tool-kit/essay/soapstone";

const CHIP =
  "rounded-full border border-border bg-card px-2.5 py-0.5 text-foreground text-xs transition-colors hover:bg-muted aria-pressed:border-primary aria-pressed:bg-primary/10 aria-pressed:text-primary";

/**
 * A word bank grouped by attitude. Clicking a word adds it to, or removes it from, the
 * comma-separated tone field. Every label comes in as a prop.
 */
export function ToneBank({
  tone,
  onToggle,
  title,
  groups,
  words,
}: {
  tone: string;
  onToggle: (word: string) => void;
  title: string;
  groups: Readonly<Record<string, string>>;
  words: Readonly<Record<string, readonly string[]>>;
}) {
  const chosen = new Set(parseTones(tone));
  return (
    <details className="rounded-lg border border-border bg-muted/30 p-3">
      <summary className={`${LABEL} cursor-pointer`}>{title}</summary>
      <div className="mt-3 space-y-3">
        {Object.keys(words).map((group) => (
          <div className="space-y-1.5" key={group}>
            <p className="font-medium text-muted-foreground text-xs">
              {groups[group]}
            </p>
            <div className="flex flex-wrap gap-1.5">
              {(words[group] ?? []).map((word) => (
                <button
                  aria-pressed={chosen.has(word)}
                  className={CHIP}
                  key={word}
                  onClick={() => onToggle(word)}
                  type="button"
                >
                  {word}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </details>
  );
}
